import circuitBoard from '../assets/photos/circuit.jpg';
import earth from '../assets/photos/earth.jpg';

/** Free-to-use photographs. Neither frame includes a person. */
export const photos = {
  circuit: {
    src: circuitBoard,
    alt: 'Close-up of a printed circuit board',
    credit: 'Alexandre Debiève / Unsplash',
  },
  earth: {
    src: earth,
    alt: 'The Earth seen from Apollo 17',
    credit: 'NASA, public domain',
  },
};
